import React, { forwardRef } from "react";
import { useMultiSelectFilterContext } from "../MultiSelectFilter.context";
var MutliSelectFilterFilter = forwardRef(function (_a, ref) {
    var placeholder = _a.placeholder, setFilter = _a.setFilter, focusPreviousElement = _a.focusPreviousElement, focusNextElement = _a.focusNextElement;
    var _b = useMultiSelectFilterContext(), multiSelectModel = _b.multiSelectModel, id = _b.id;
    var onKeyDownFilter = function (event) {
        if (event.key === "Tab") {
            if (event.shiftKey) {
                focusPreviousElement(event);
            }
            else {
                focusNextElement(event);
            }
            event.preventDefault();
        }
    };
    return (React.createElement("div", { className: "ssg-multi-select-filter__filter" },
        React.createElement("input", { ref: ref, name: id + "-filter", className: "fr-input", type: "text", role: "textbox", "aria-label": "Filtrer les options", placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "Filtrer...", value: multiSelectModel.filter, onKeyDown: onKeyDownFilter, onChange: function (e) { return setFilter(e.target.value); } })));
});
export default MutliSelectFilterFilter;
